import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useState } from 'react';
import { styleVariables, TextAreaBox, StyledHeadTitle } from '@lib/common';
import { Button, Skeleton, Space, Tooltip, Row, Col } from 'antd';
import styled from 'styled-components';
import { SubmissionScore } from '@module/assignment';
import { UnixTimestamp } from '@module/form';
import { CommentBox } from '../comment/comment-box.component';
import { EditOutlined, InfoCircleFilled } from '@ant-design/icons';
import { CommentPreview } from '../comment/comment-preview.component';
import { PracticeSubmissionStatusResultComponent } from '../../pratice-submission-status-result.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledInformationCard = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__StyledInformationCard",
  componentId: "sc-36tcba-0"
})(["border-radius:16px;box-shadow:0px 3px 6px rgba(0,0,0,0.12);background-color:", ";padding:16px 16px 16px 16px;"], styleVariables.colors.gray1);
var UserInformationCard = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__UserInformationCard",
  componentId: "sc-36tcba-1"
})(["border-radius:8px;padding:16px;"]);
var AvatarCircle = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__AvatarCircle",
  componentId: "sc-36tcba-2"
})(["width:56px;height:56px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background-color:", ";color:", ";font-weight:700;font-size:18px;margin-right:12px;"], styleVariables.colors.blue1, styleVariables.colors.blue2);
var UserRow = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__UserRow",
  componentId: "sc-36tcba-3"
})(["display:flex;align-items:center;"]);
var StyledSpace = styled(Space).withConfig({
  displayName: "submission-preview-headercomponent__StyledSpace",
  componentId: "sc-36tcba-4"
})(["width:100%;"]);
var BoldText = styled.label.withConfig({
  displayName: "submission-preview-headercomponent__BoldText",
  componentId: "sc-36tcba-5"
})(["font-weight:600;font-size:14px;", ""], function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var GrayText = styled.label.withConfig({
  displayName: "submission-preview-headercomponent__GrayText",
  componentId: "sc-36tcba-6"
})(["font-weight:400;font-size:14px;line-height:24px;color:", ";", ""], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var InformationSummary = styled(Row).withConfig({
  displayName: "submission-preview-headercomponent__InformationSummary",
  componentId: "sc-36tcba-7"
})([""]);
var ResultCol = styled(Col).withConfig({
  displayName: "submission-preview-headercomponent__ResultCol",
  componentId: "sc-36tcba-8"
})(["display:flex;"]);
var ResultWrapper = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__ResultWrapper",
  componentId: "sc-36tcba-9"
})(["display:flex;flex-direction:column;width:100%;flex:1;& > *{height:100%;}.ant-col{max-width:none !important;}"]);
var SubmissionResultCard = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__SubmissionResultCard",
  componentId: "sc-36tcba-10"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding:16px;border-radius:8px;gap:6px;background-color:", ";height:100%;"], styleVariables.colors.blue1);
var ScoreGrayText = styled.label.withConfig({
  displayName: "submission-preview-headercomponent__ScoreGrayText",
  componentId: "sc-36tcba-11"
})(["font-weight:400;font-size:14px;line-height:24px;color:", ";", " text-align:center;width:100%;"], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var HeadingText = styled(ScoreGrayText).withConfig({
  displayName: "submission-preview-headercomponent__HeadingText",
  componentId: "sc-36tcba-12"
})(["font-weight:700;"]);
var SubmissionScoreText = styled.label.withConfig({
  displayName: "submission-preview-headercomponent__SubmissionScoreText",
  componentId: "sc-36tcba-13"
})(["font-weight:600;font-size:24px;line-height:28px;color:", ";", ""], styleVariables.colors.blue2, function (props) {
  return props.theme.media.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 28px;\n  "])));
});
var SubmissionScoreSmall = styled.span.withConfig({
  displayName: "submission-preview-headercomponent__SubmissionScoreSmall",
  componentId: "sc-36tcba-14"
})(["color:", ";font-weight:600;font-size:16px;margin-left:6px;"], styleVariables.colors.gray11);
var StyledTitle = styled.label.withConfig({
  displayName: "submission-preview-headercomponent__StyledTitle",
  componentId: "sc-36tcba-15"
})(["font-size:", ";font-weight:", ";"], styleVariables.font.fontSizeOriginal, styleVariables.font.fontWeightStrong);
var SectionRow = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__SectionRow",
  componentId: "sc-36tcba-16"
})(["display:flex;gap:12px;flex-wrap:wrap;width:100%;"]);
var SectionCard = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__SectionCard",
  componentId: "sc-36tcba-17"
})(["flex:1;min-width:120px;padding:10px 14px;border-radius:8px;border:1px solid ", ";background:", ";display:flex;flex-direction:column;gap:4px;"], styleVariables.colors.gray3, styleVariables.colors.gray1);
var SectionLabel = styled.span.withConfig({
  displayName: "submission-preview-headercomponent__SectionLabel",
  componentId: "sc-36tcba-18"
})(["font-size:11px;font-weight:600;letter-spacing:0.8px;text-transform:uppercase;color:", ";"], styleVariables.colors.gray11);
var SectionCorrectText = styled.span.withConfig({
  displayName: "submission-preview-headercomponent__SectionCorrectText",
  componentId: "sc-36tcba-19"
})(["font-size:13px;font-weight:600;color:", ";"], styleVariables.colors.gray13);
var StyledSectionProgressBar = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__StyledSectionProgressBar",
  componentId: "sc-36tcba-20"
})(["width:100%;height:5px;border-radius:999px;background:", ";position:relative;overflow:hidden;margin-top:4px;&::after{content:'';position:absolute;left:0;top:0;height:100%;width:", "%;background:", ";}"], styleVariables.colors.gray3, function (p) {
  return Math.min(100, Math.max(0, p.$percent));
}, styleVariables.colors.green1);
var StyledSpaceContainer = styled(Space).withConfig({
  displayName: "submission-preview-headercomponent__StyledSpaceContainer",
  componentId: "sc-36tcba-21"
})(["width:100%;"]);
var StyledTooltip = styled(Tooltip).withConfig({
  displayName: "submission-preview-headercomponent__StyledTooltip",
  componentId: "sc-36tcba-22"
})([""]);
var StyledProgressBar = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__StyledProgressBar",
  componentId: "sc-36tcba-23"
})(["width:100%;height:10px;border-radius:999px;background:", ";position:relative;overflow:hidden;margin-top:4px;margin-bottom:2px;&::after{content:'';position:absolute;left:0;top:0;height:100%;width:", "%;background:", ";}"], styleVariables.colors.gray3, function (p) {
  return Math.min(100, Math.max(0, p.$percent));
}, styleVariables.colors.green1);
var FeedbackCard = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__FeedbackCard",
  componentId: "sc-36tcba-24"
})(["display:flex;flex-direction:column;gap:6px;padding:10px 12px;border-radius:8px;background:", ";border-left:4px solid ", ";"], styleVariables.colors.gray2, styleVariables.colors.blue2);
var FeedbackHeader = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__FeedbackHeader",
  componentId: "sc-36tcba-25"
})(["display:flex;align-items:center;gap:8px;font-weight:600;color:", ";"], styleVariables.colors.gray13);
var ScrollArea = styled.div.withConfig({
  displayName: "submission-preview-headercomponent__ScrollArea",
  componentId: "sc-36tcba-26"
})(["max-height:140px;overflow-y:auto;padding-right:4px;"]);
var SubmittedTag = styled.span.withConfig({
  displayName: "submission-preview-headercomponent__SubmittedTag",
  componentId: "sc-36tcba-27"
})(["display:inline-flex;align-items:center;gap:6px;padding:6px 10px;border-radius:999px;background:", ";color:", ";font-weight:600;font-size:12px;"], styleVariables.colors.blue1, styleVariables.colors.blue2);
var StyledTextAreaBox = styled(TextAreaBox).withConfig({
  displayName: "submission-preview-headercomponent__StyledTextAreaBox",
  componentId: "sc-36tcba-28"
})(["background-color:transparent;cursor:pointer;&:hover{background-color:", ";}"], styleVariables.colors.gray1);
export var SubmissionPreviewHeader = function SubmissionPreviewHeader(props) {
  var isLoadingGetFormReleaseById = props.isLoadingGetFormReleaseById,
      isLoadingGetAttendeeById = props.isLoadingGetAttendeeById,
      isLoadingGetSubmissionById = props.isLoadingGetSubmissionById,
      isLoadingGetAssignmentById = props.isLoadingGetAssignmentById,
      formRelease = props.formRelease,
      assignment = props.assignment,
      attendee = props.attendee,
      submission = props.submission,
      label = props.label,
      _props$isShowingTotal = props.isShowingTotalScore,
      isShowingTotalScore = _props$isShowingTotal === void 0 ? true : _props$isShowingTotal,
      isUpdating = props.isUpdating,
      onComment = props.onComment,
      isPreviewMode = props.isPreviewMode,
      correctQuestionsPerSection = props.correctQuestionsPerSection,
      _props$shouldShowTitl = props.shouldShowTitle,
      shouldShowTitle = _props$shouldShowTitl === void 0 ? true : _props$shouldShowTitl,
      children = props.children;

  var _useState = useState(false),
      isCommentEditing = _useState[0],
      setIsCommentEditing = _useState[1];

  useEffect(function () {
    if (!isUpdating) {
      setIsCommentEditing(false);
    }
  }, [isUpdating]);

  var renderUserInformation = function renderUserInformation() {
    var _attendee$firstName, _attendee$lastName;

    if (isLoadingGetAttendeeById) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    var userExtra = submission !== null && submission !== void 0 && submission.submitTime ? /*#__PURE__*/_jsxs(SubmittedTag, {
      children: [label.submittedOn, ": ", UnixTimestamp.convertToDate(submission.submitTime)]
    }) : undefined;
    return /*#__PURE__*/_jsx(Space, {
      direction: "vertical",
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsxs(UserRow, {
        children: [/*#__PURE__*/_jsxs(AvatarCircle, {
          children: [(((_attendee$firstName = attendee.firstName) === null || _attendee$firstName === void 0 ? void 0 : _attendee$firstName[0]) || '').toUpperCase(), (((_attendee$lastName = attendee.lastName) === null || _attendee$lastName === void 0 ? void 0 : _attendee$lastName[0]) || '').toUpperCase()]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(BoldText, {
            children: [attendee.firstName, " ", attendee.lastName]
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(GrayText, {
              children: attendee.email
            })
          }), userExtra && /*#__PURE__*/_jsx("div", {
            children: userExtra
          })]
        })]
      })
    });
  };

  var renderAssignmentTitle = function renderAssignmentTitle() {
    if (isLoadingGetAssignmentById) {
      return /*#__PURE__*/_jsx(Skeleton.Button, {
        size: "large",
        block: true,
        active: true
      });
    }

    return /*#__PURE__*/_jsx(_Fragment, {
      children: shouldShowTitle && /*#__PURE__*/_jsx(StyledHeadTitle, {
        children: assignment.title
      })
    });
  };

  var renderSubmissionResultInformation = function renderSubmissionResultInformation() {
    var _ref, _correctQuestionsPerS, _submission$result, _label$numberOfCorrec, _submission$result2, _submission$result2$s;

    var isLoadingResources = isLoadingGetSubmissionById || isLoadingGetAssignmentById || isLoadingGetFormReleaseById;

    if (isLoadingResources) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    if (isShowingTotalScore) {
      var _label$totalScore;

      var totalScore = formRelease.sections.reduce(function (sum, currentSection) {
        return sum + currentSection.totalScore;
      }, 0);
      var numericScore = submission.result.score === SubmissionScore["default"].value ? 0 : submission.result.score;

      var _percent = totalScore > 0 ? Math.round(numericScore / totalScore * 100) : 0;

      return /*#__PURE__*/_jsxs(SubmissionResultCard, {
        children: [/*#__PURE__*/_jsx(HeadingText, {
          children: (_label$totalScore = label.totalScore) === null || _label$totalScore === void 0 ? void 0 : _label$totalScore.toUpperCase()
        }), /*#__PURE__*/_jsxs(SubmissionScoreText, {
          children: [numericScore, /*#__PURE__*/_jsxs(SubmissionScoreSmall, {
            children: ["/", totalScore, " ", label.score]
          })]
        }), numericScore > 0 && /*#__PURE__*/_jsx(StyledProgressBar, {
          $percent: _percent
        })]
      });
    }

    var totalQuestions = formRelease.sections.reduce(function (sum, currentSection) {
      var _currentSection$total;

      return sum + ((_currentSection$total = currentSection.totalQuestion) !== null && _currentSection$total !== void 0 ? _currentSection$total : 0);
    }, 0);
    var totalCorrect = (_ref = (_correctQuestionsPerS = correctQuestionsPerSection === null || correctQuestionsPerSection === void 0 ? void 0 : correctQuestionsPerSection.reduce(function (sum, n) {
      return sum + n;
    }, 0)) !== null && _correctQuestionsPerS !== void 0 ? _correctQuestionsPerS : (_submission$result = submission.result) === null || _submission$result === void 0 ? void 0 : _submission$result.numberOfCorrectAnswers) !== null && _ref !== void 0 ? _ref : 0;
    var percent = totalQuestions > 0 ? Math.round(totalCorrect / totalQuestions * 100) : 0;
    return /*#__PURE__*/_jsxs(SubmissionResultCard, {
      children: [/*#__PURE__*/_jsx(HeadingText, {
        children: (_label$numberOfCorrec = label.numberOfCorrectAnswer) === null || _label$numberOfCorrec === void 0 ? void 0 : _label$numberOfCorrec.toUpperCase()
      }), /*#__PURE__*/_jsxs(SubmissionScoreText, {
        children: [totalCorrect, /*#__PURE__*/_jsxs(SubmissionScoreSmall, {
          children: ["/", totalQuestions, " ", label.question]
        })]
      }), totalCorrect > 0 && /*#__PURE__*/_jsx(StyledProgressBar, {
        $percent: percent
      }), /*#__PURE__*/_jsx(PracticeSubmissionStatusResultComponent, {
        status: submission === null || submission === void 0 ? void 0 : (_submission$result2 = submission.result) === null || _submission$result2 === void 0 ? void 0 : (_submission$result2$s = _submission$result2.status) === null || _submission$result2$s === void 0 ? void 0 : _submission$result2$s.id
      })]
    });
  };

  var renderSectionSummaries = function renderSectionSummaries() {
    if (isLoadingGetFormReleaseById) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(SectionRow, {
      children: formRelease.sections.map(function (section, index) {
        var _correctQuestionsPerS2, _section$totalQuestio;

        var correct = (_correctQuestionsPerS2 = correctQuestionsPerSection === null || correctQuestionsPerSection === void 0 ? void 0 : correctQuestionsPerSection[index]) !== null && _correctQuestionsPerS2 !== void 0 ? _correctQuestionsPerS2 : 0;
        var total = (_section$totalQuestio = section.totalQuestion) !== null && _section$totalQuestio !== void 0 ? _section$totalQuestio : 0;
        var percent = total > 0 ? Math.round(correct / total * 100) : 0;
        return /*#__PURE__*/_jsxs(SectionCard, {
          children: [/*#__PURE__*/_jsxs(SectionLabel, {
            children: [label.section, " ", index + 1]
          }), /*#__PURE__*/_jsxs(SectionCorrectText, {
            children: [correct, "/", total, " ", label.numberOfCorrectAnswer]
          }), /*#__PURE__*/_jsx(StyledSectionProgressBar, {
            $percent: percent
          })]
        }, index);
      })
    });
  };

  var renderComment = function renderComment() {
    var commentPreviewLabel = {
      noContent: label.noComment,
      seeMore: label.seeMore,
      seeLess: label.seeLess
    };

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(CommentPreview, {
        value: submission !== null && submission !== void 0 && submission.isEmptyComment() ? '' : submission === null || submission === void 0 ? void 0 : submission.comment,
        label: commentPreviewLabel
      });
    }

    if (isCommentEditing) {
      return /*#__PURE__*/_jsx(CommentBox, {
        label: _objectSpread(_objectSpread({}, label), {}, {
          placeholder: label.enterComment
        }),
        onSave: onComment,
        value: submission === null || submission === void 0 ? void 0 : submission.comment,
        onCancel: function onCancel() {
          return setIsCommentEditing(false);
        },
        loading: isUpdating
      });
    }

    if (submission !== null && submission !== void 0 && submission.isEmptyComment()) {
      if (assignment.isEnded()) {
        return /*#__PURE__*/_jsx(StyledTextAreaBox, {
          placeholder: label.enterComment,
          onClick: function onClick() {
            return setIsCommentEditing(true);
          }
        });
      }

      return /*#__PURE__*/_jsx(StyledTooltip, {
        title: label.disabledText,
        children: /*#__PURE__*/_jsx(StyledTextAreaBox, {
          placeholder: label.enterComment,
          disabled: true
        })
      });
    }

    return /*#__PURE__*/_jsx(CommentPreview, {
      value: submission === null || submission === void 0 ? void 0 : submission.comment,
      label: commentPreviewLabel
    });
  };

  return /*#__PURE__*/_jsx(StyledInformationCard, {
    children: /*#__PURE__*/_jsx(StyledSpace, {
      direction: "vertical",
      size: "small",
      children: !assignment ? /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 4
        }
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [renderAssignmentTitle(), /*#__PURE__*/_jsxs(InformationSummary, {
          gutter: 16,
          children: [/*#__PURE__*/_jsx(Col, {
            xs: 24,
            xl: 16,
            flex: "auto",
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              size: "small",
              style: {
                width: '100%'
              },
              children: [/*#__PURE__*/_jsx(UserInformationCard, {
                children: renderUserInformation()
              }), !isLoadingGetAttendeeById && /*#__PURE__*/_jsxs(StyledSpaceContainer, {
                direction: "vertical",
                size: "small",
                children: [renderSectionSummaries(), /*#__PURE__*/_jsxs(FeedbackCard, {
                  children: [/*#__PURE__*/_jsxs(FeedbackHeader, {
                    children: [/*#__PURE__*/_jsx(InfoCircleFilled, {
                      style: {
                        color: styleVariables.colors.blue2
                      }
                    }), /*#__PURE__*/_jsx(StyledTitle, {
                      children: label.teacherComment
                    }), !isCommentEditing && !(submission !== null && submission !== void 0 && submission.isEmptyComment()) && !isPreviewMode && /*#__PURE__*/_jsx(Button, {
                      icon: /*#__PURE__*/_jsx(EditOutlined, {}),
                      type: "text",
                      shape: "circle",
                      onClick: function onClick() {
                        return setIsCommentEditing(true);
                      },
                      disabled: isUpdating
                    })]
                  }), renderComment()]
                })]
              }), children && /*#__PURE__*/_jsx("div", {
                children: children
              })]
            })
          }), /*#__PURE__*/_jsx(ResultCol, {
            xs: 24,
            xl: 8,
            flex: "auto",
            children: /*#__PURE__*/_jsx(ResultWrapper, {
              children: renderSubmissionResultInformation()
            })
          })]
        })]
      })
    })
  });
};